import api from 'api'
import { CACHE_TAG_ACCOUNTS_VERSION_LIST, CACHE_TAG_ADDRESS_VERSION_LIST } from 'api/cacheTagTypes'

export const extendApiSlice = api.injectEndpoints({
  endpoints: build => ({
    updateAccount: build.mutation({
      query: body => ({ url: `/api/v1/core/accounts/${body.id}`, method: 'PUT', body }),
      invalidatesTags: (result, error, body) => {
        const tags = [{ type: CACHE_TAG_ACCOUNTS_VERSION_LIST, id: body?.id }]
        const addrId = body?.billingAddress?.id
        if (addrId) tags.push({ type: CACHE_TAG_ADDRESS_VERSION_LIST, id: addrId })
        return tags
      },
    }),
  }),
})

export const { useUpdateAccountMutation } = extendApiSlice
